interface CardItem {
  tag: string;
  title: string;
  summary: string;
  imageUrl: string;
  imageAlt: string;
}

const cardItems: CardItem[] = [
  {
    tag: '重磅爆料',
    title: '某当红女星被曝隐婚生子，丈夫身份令人震惊',
    summary: '据知情人士透露，该女星三年前已秘密领证，孩子如今已两岁，丈夫系圈外知名企业家。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20entertainment%20news%20secret%20marriage%20story%2C%20elegant%20warm%20golden%20and%20soft%20pink%20tones%2C%20silhouette%20figures%20with%20mysterious%20atmosphere%2C%20modern%20Chinese%20tabloid%20aesthetic%2C%20soft%20cinematic%20lighting&width=600&height=400&seq=card-item-01&orientation=landscape',
    imageAlt: '当红女星隐婚生子，丈夫身份震惊众人',
  },
  {
    tag: '商业秘闻',
    title: '知名企业家涉嫌财务造假，公司股价一夜暴跌',
    summary: '多家机构发布看空报告，监管部门已介入调查，涉及金额或高达数十亿元。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20scandal%20illustration%20with%20descending%20graph%20lines%2C%20warm%20dark%20amber%20and%20coral%20color%20scheme%2C%20business%20news%20editorial%20style%2C%20dramatic%20shadows%20and%20highlights%2C%20modern%20minimalist%20composition&width=600&height=400&seq=card-item-02&orientation=landscape',
    imageAlt: '知名企业家涉嫌财务造假，股价暴跌',
  },
  {
    tag: '选秀风波',
    title: '某选秀节目冠军被质疑买票，粉丝集体维权要求重审',
    summary: '投票数据异常引发广泛争议，节目组回应称将配合第三方审计机构进行全面核查。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20talent%20show%20stage%20with%20dramatic%20spotlight%20and%20crowd%20silhouettes%2C%20warm%20vermillion%20and%20golden%20tones%2C%20entertainment%20industry%20editorial%20photography%20style%2C%20dynamic%20lighting%20and%20atmosphere&width=600&height=400&seq=card-item-03&orientation=landscape',
    imageAlt: '选秀冠军被质疑买票，粉丝集体维权',
  },
  {
    tag: '番位之争',
    title: '两位顶流因番位之争闹掰，新剧宣传期全程零互动',
    summary: '剧组宣发陷入尴尬局面，双方团队均拒绝退让，粉丝互撕持续升级引发行业反思。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20dual%20silhouettes%20facing%20opposite%20directions%20with%20dramatic%20lighting%20split%2C%20warm%20amber%20and%20cool%20neutral%20tones%2C%20entertainment%20news%20artistic%20illustration%2C%20editorial%20style%2C%20high%20contrast&width=600&height=400&seq=card-item-04&orientation=landscape',
    imageAlt: '两位顶流番位之争闹掰，新剧零互动',
  },
  {
    tag: '人设崩塌',
    title: '某网红被扒出早年黑历史，清纯人设一夜之间彻底崩塌',
    summary: '网友深挖社交平台旧帖，多条不当言论和争议照片被曝光，品牌方紧急解约。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20cracked%20mask%20or%20facade%20metaphor%20illustration%2C%20warm%20dramatic%20lighting%20with%20shadows%2C%20vermillion%20and%20dark%20amber%20tones%2C%20social%20media%20scandal%20editorial%20style%2C%20modern%20artistic%20composition&width=600&height=400&seq=card-item-05&orientation=landscape',
    imageAlt: '网红黑历史曝光，清纯人设一夜崩塌',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            今日大瓜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日精选重磅爆料，一手资讯深度解读，吃瓜从不等待
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-medium text-foreground-900 leading-snug mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}